import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = _resolveComponent("RouterLink");
    return ($setup.getOrder($setup.route.query.sort) === 1)
        ? (_openBlock(), _createBlock(_component_RouterLink, {
            key: 0,
            to: { query: { ...$setup.route.query, ...{ sort: $setup.flipOrder($setup.route.query.sort), startIndex: 1 } } },
            class: _normalizeClass([$setup.linkClass])
        }, {
            default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.$t('Ascending')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to", "class"]))
        : (_openBlock(), _createBlock(_component_RouterLink, {
            key: 1,
            to: { query: { ...$setup.route.query, ...{ sort: $setup.flipOrder($setup.route.query.sort), startIndex: 1 } } },
            class: _normalizeClass([$setup.linkClass])
        }, {
            default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.$t('Descending')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to", "class"]));
}
